import $ from '../vendor/jquery';



// WEBPACK FOOTER //
// ./public/assets/js/src/components/gallery.js